
define('text!modules/targeting/pixel/templates/panel.html',[],function () { return '<div class="w-box w-PixelTargeting">\n  <div class="w-panel-body w-body"></div>\n  <div class="w-foot">{{>footer}}</div>\n</div>\n';});

